import axios from '../modules/marketplace/axios-marketplace';

const list = (params) => axios.get('/bancos', { params });

export default {
  list,
};
